import React from 'react';

export const NameTitle = ({ model, record }) => (
  <span>{model} {record ? `"${record.name}"` : ''}</span>
);